import React from 'react';
import { Flex, Card, message, Modal, Image, Rate, Tag } from 'antd';
import { QrcodeOutlined, ShareAltOutlined, LinkOutlined, EditOutlined, CopyOutlined, FileTextOutlined, ToTopOutlined } from '@ant-design/icons';
// import CardContent from './card-content';
import { getCurrentShopId } from '../../pages/shop/get-current-shop';
import { openWxminiGoods } from './tools';

export default ({ content = {}, onStatusChange, accId }) => {
    const [currentShopId, setCurrentShopId] = React.useState(null);
    
    React.useEffect(() => {
        const fetchCurrentShopId = async () => {
            const shopId = await getCurrentShopId();
            setCurrentShopId(shopId);
        };
        
        fetchCurrentShopId();
    }, []);

    const {
        goodsId, cateId, ownerShopId, shopId_shops = [],
        type, title, status, minNum, realSaleNum, offlineSaleNum, inventory, shortDescription, sysCateId,
        properties, price, marketPrice, prepaidAmount, createTime, uuid, unit, mainImages,
        rating = {},
    } = content;

    // 商品发布店铺
    const publishShop = shopId_shops.find(item => item.shopId === ownerShopId);
    
    // 构造服务区域
    const areas = [];
    shopId_shops.forEach(item => {
        if(item.shop_biz_address) {
            if(item.shop_biz_address.city) areas.push(item.shop_biz_address.city);
            else if(item.shop_biz_address.province) areas.push(item.shop_biz_address.province);
        }
    });
    if(areas.length === 0) {
        areas.push('未知');
    }

    const CardHeader = () => {
        return (
            <Flex justify="space-between">
                <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                    {title}
                </div>
                <Flex gap={10}>
                    {/* <div><ShareAltOutlined /></div>
                    <div><QrcodeOutlined /></div> */}
                    <a onClick={onWxminiUrlClick}><LinkOutlined /></a>
                </Flex>
            </Flex>
        )
    }

    const actions = [
        <a href={`/goods/create?goodsId=${goodsId}&action=edit`}><EditOutlined key="edit" /> 编辑</a>,
    ]
    console.log('status', status);

    const changeStatus = async (status) => {
        if(!status) return;
        if(!currentShopId) {
            message.error('未获取到店铺信息');
            return;
        }

        let response = await fetch(`/api/goods/shelf`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                goodsId,
                status,
                accId,
                shopId: currentShopId
            }),
        }).catch(error => {
            message.error(error);
        });

        if(response.status === 403) {
            message.error('没有权限');
            return;
        }

        let result = await response.json();

        if(result.success) {
            message.success('操作成功');
            setTimeout(() => {
                onStatusChange?.(goodsId, status)
            }, 800)
        }

        return result;
    }

    const onDelete = async (goodsId) => {
        Modal.confirm({
            title: '确定删除？',
            content: '删除后商品将不再显示在店铺中',
            onOk: () => {
                requestDelete(goodsId).then(result => {
                    if(result.success) {
                        message.success('删除成功');
                        onStatusChange?.(goodsId, -1)
                    }
                });
            }
        })
    }

    const requestDelete = async (goodsId) => {
        if(!currentShopId) {
            message.error('未获取到店铺信息');
            return;
        }
        
        const response = await fetch(`/api/goods/remove`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ goodsId, accId, shopId: currentShopId }),
        });

        return await response.json();
    }
    
    if (currentShopId && status === 2) {
        actions.push(<div onClick={() => changeStatus(1)}><ToTopOutlined key="top" /> 上架</div>)
    } else if(currentShopId && status === 1) {
        actions.push(<div onClick={() => changeStatus(2)}><ToTopOutlined rotate={180} /> 下架</div>)
    }

    actions.push(<a href={`/goods/create?goodsId=${goodsId}&action=copy`}><FileTextOutlined /> 复制</a>,)
    actions.push(<a href={`/goods/create?goodsId=${goodsId}&action=view`}><FileTextOutlined /> 详情</a>,)
    actions.push(<div onClick={() => onDelete(goodsId)}>删除</div>)

    const onWxminiUrlClick = async () => {
        if(!currentShopId) {
            message.error('未获取到店铺信息');
            return;
        }
        
        await openWxminiGoods(accId, currentShopId, goodsId);
    }

    return (
        <Card title={<CardHeader />} style={{minWidth: 360, marginBottom: 10, maxWidth: 456, width: '100%'}}
            actions={actions}
        >
            <Flex justify="" align="left" gap={10} style={{fontSize: 12}}>
                <Image
                    style={{width: '80px', height: '80px'}}
                    src={`//img.yxdj.tech/${mainImages[0]}?x-oss-process=image/resize,w_200`}
                />
                <div>
                    <div>价格：{price/100}元/{unit} <del>{marketPrice/100}元</del></div>
                    <div>销量：{realSaleNum} &nbsp; 库存：{inventory}</div>
                    <div>服务评分：{rating.score ? <Rate allowHalf defaultValue={rating.score} /> : '暂无评分'} </div>
                    <div>服务区域：{ areas.map((c, i) => (<Tag key={i}>{c}</Tag>))}</div>
                    <div>发布店铺：{publishShop?.title}</div>
                </div>
            </Flex>
        </Card>
    )
}